import "./scss/style.scss";
import { enableSectionToggle } from "./js/lib/utils";
import Cookies from "../template-parts/common/modals/cookies/cookies";

// All imports above this line
enableSectionToggle();

const libraries = {};
window.libraries = [];
window.modules = [];
window.captchaLoaded = false;
window.googleapi = false;

// Load cookies banner when not in WordPress Dashboard
if (!window.location.pathname.includes("/wp-admin/")) {
  window.cookies = new Cookies();
}

// Modules loader
import(/* webpackChunkName: "modules-loader" */ "./js/modules-loader").then(
  ({ default: ModulesLoader }) => {
    // Assign instance to window for global access, avoiding 'no-new' side effect
    window.modulesLoader = new ModulesLoader();
  },
);

// Load libraries
libraries.lottieLoader = {
  fileName: "lottie",
  cssClassName: ".lottie",
};
libraries.lazyLoading = {
  fileName: "lazy-loading",
  cssClassName: ".barba-container",
};
libraries.barba = {
  fileName: "barba",
  cssClassName: ".barba-container",
};
window.loadJsLibraries(libraries);
